import React, { forwardRef, useState } from "react";
import DatePicker from "react-datepicker";

const ProfileDatePicker = ({
  date,
  setDate,
  required = true,
  review = false,
}) => {
  const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
    <button
      type="button"
      className={`d-flex align-items-center justify-content-between profile_date_picker rounded bg-white datePicker`}
      onClick={setDate && onClick}
      ref={ref}
    >
      <small className="small-text">{value && value}</small>
      <div className="d-flex align-items-center">
        <small className="d-flex align-items-center">
          <i className="fa fa-calendar fs-18" />
        </small>
      </div>
    </button>
  ));

  return (
    <DatePicker
      selected={date}
      onChange={(date) => setDate(date)}
      customInput={<ExampleCustomInput />}
      dateFormat="dd MMM yyyy"
    />
  );
};

export default ProfileDatePicker;
